import React from 'react'
import { clsx } from 'clsx'

const STATUS_CONFIG: Record<number, { text: string; className: string }> = {
  0: { text: 'На модерации', className: 'bg-warning-50 text-warning-700' },
  1: { text: 'Активно', className: 'bg-success-50 text-success-700' },
  2: { text: 'Отклонено', className: 'bg-error-50 text-error-700' },
  3: { text: 'Отключено', className: 'bg-gray-100 text-gray-800' },
}

interface Props {
  status: number
}

export const LegalEntityStatusBadge: React.FC<Props> = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    text: 'Неизвестно',
    className: 'bg-gray-100 text-gray-800',
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.className
      )}
    >
      {config.text}
    </span>
  )
}
